import { render, staticRenderFns } from "./ChatAttachment.vue?vue&type=template&id=6828b4d4"
import script from "./ChatAttachment.vue?vue&type=script&lang=js"
export * from "./ChatAttachment.vue?vue&type=script&lang=js"
import style0 from "./ChatAttachment.vue?vue&type=style&index=0&id=6828b4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports